export default {
  dashboard: {
    access: {
      table: {
        last_event: "vergangene Events",
        personal: "Arbeitnehmer",
        terminal_type: "Terminal Typ",
        general_info: "Allgemeine Informationen",
        terminal: "Terminal",
        event_type: "Event Typ",
        identity_type: "Identitätstyp",
        time: "Zeit",
        event: "Event",
        location: "Standort",
        place: "Ort",
        place_beacon: " Beacon platzieren",
        minor: "gering",
        major: "hoch",
        parent: "Überordnung",
        duration: "Dauer",
        first_seen: "zuerst gesehen",
        last_seen: "zuletzt gesehen",
        max_person_count: "maximale Personananzahl",
        begin_date_time: "Startzeit und -datum",
        end_date_time: "Endzeit und -datum",
        employee_dialog_title: "Enter – Exit Information Personal",
        empty_zone_message: "Leere Zone",
        loading_message: "wird geladen"
      },
      monthly_dashboard: "monatliches Dashboard",
      monthly_events: "monatliche Events",
      monthly_timesheet_report: "monatlichen Timesheet Bericht",
      absence: "Abwesenheit",
      incalculable: "nicht berechbar",
      lates: "verspätete Ankunft",
      overtime: "Überstunden",
      early_leaver: "verfrühtes Schichtende",
      missing_time: "verpasste Zeiten",
      total_tardiness_average: "Total Verspätungsdurchschnitt",
      total_leaver_average: "Total Durchschnitt verfrühtes Schichtende",
      total_overtime_average: "Total Überstundendurchschnitt",
      tardiness_minute: "Verspätung in Minuten",
      early_minute: "verfrühter Schichtbeginn in Minuten",
      overtime_minute: "Überstunden in Minuten",
      short_minute: "min",
      today: "Heute"
    },
    currency: {
      buying: "zu kaufen",
      selling: "zu verkaufen",
      currencies: "Währung"
    },
    about: {
      about: "Über",
      mission: "Mission",
      vision: "Vision"
    },
    menu_of_day: "Tagesmenü",
    messages: {
      no_data_reminders: "Keine Daten - Erinnerungen",
      no_data_messages: "Keine Daten - Benachrichtigungen",
      no_data_leaves: "Keine Daten - Urlaubsanträge",
      no_data_overtimes: "Keine Daten - Überstundenanträge",
      no_data_expenses: "Keine Daten - Kostenabfragne",
      no_data_imprests: "Keine Daten - Zahlstellenanfragen",
      no_data_incalculables: "Keine Daten – unberechenbare Inhalte",
      no_data_absences: "Keine Daten - Abwesenheiten"
    },
    request_type: {
      leave: "Urlaubsanträge",
      overtime: "Überstundenanträge",
      expense: "Kostenabfragen",
      imprest: "Zahlstellenanfragen"
    },
    weather_forecast: "Wettervorhersage",
    reminder_tab_title: "Erinnerungen",
    message_tab_title: "Nachrichten",
    data_type_enum: {
      LEAVE_REQUEST: "Time Off Requests",
      ACTIVITY: "Activities",
      REMINDER: "Reminders"
    }
  }
};
